import { t, useLanguage } from "@/i18n/LanguageContext";import { Plus, Trash2 } from "lucide-react";

export default function ListEditor({ title, items, fields, onChange, testid }) {useLanguage();
  const update = (i, key, value) =>
  onChange(items.map((it, idx) => idx === i ? { ...it, [key]: value } : it));
  const add = () =>
  onChange([...items, Object.fromEntries(fields.map((f) => [f.key, ""]))]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid={`${testid}-editor`}>
      <div className="mb-5 flex items-center justify-between">
        <h3 className="font-display text-lg font-bold text-brand-navydeep">{t(title)}</h3>
        <button type="button" data-testid={`${testid}-add-button`} onClick={add}
        className="inline-flex items-center gap-1.5 rounded-full bg-brand-limelight px-4 py-2 text-xs font-bold text-brand-navy transition-colors hover:bg-brand-lime">
          <Plus className="h-3.5 w-3.5" />{t(" Aggiungi")}
        </button>
      </div>
      <div className="space-y-4">
        {t(items.map((item, i) =>
        <div key={i} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
            <div className="grid gap-3 sm:grid-cols-2">
              {t(fields.map((f) =>
            <div key={f.key} className={f.wide ? "sm:col-span-2" : ""}>
                  <label className="mb-1 block text-[10px] font-bold uppercase tracking-wider text-slate-500">{t(f.label)}</label>
                  {t(f.textarea ?
              <textarea rows={2} value={item[f.key]} onChange={(e) => update(i, f.key, e.target.value)}
              data-testid={`${testid}-${i}-${f.key}`}
              className="w-full resize-none rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-brand-navy" /> :

              <input value={item[f.key]} onChange={(e) => update(i, f.key, e.target.value)}
              data-testid={`${testid}-${i}-${f.key}`}
              className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-brand-navy" />)
              }
                </div>
            ))}
            </div>
            <button type="button" data-testid={`${testid}-${i}-remove`} onClick={() => remove(i)}
          className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-red-500 hover:text-red-700">
              <Trash2 className="h-3.5 w-3.5" />{t(" Rimuovi")}
          </button>
          </div>
        ))}
      </div>
    </div>);

}
